export function isValuePublisher(blockProto) {
    return 'valuePublisherConfig' in blockProto && blockProto.valuePublisherConfig !== undefined;
}
export const ValuePublisherStatic = {
    isValuePublisher,
};
